var _path, _path2, _line, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _circle2, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 52,
    viewBox: "0 0 58 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3636 3.2793H23.6322L16.0469 10.8647V21.5953L23.6322 29.1807H34.3636L41.9489 21.5953V10.8674L34.3636 3.2793Z",
    fill: "#F1F2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3675 1H23.6361L16.0508 8.58536V19.316L23.6361 26.9014H34.3675L41.9528 19.316V8.5881L34.3675 1Z",
    stroke: "#1B4458",
    strokeWidth: 0.683089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.53686,
    y1: 38.5999,
    x2: 51.4554,
    y2: 38.5999,
    stroke: "#1B4458",
    strokeWidth: 0.683089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 38.9422H3.42838L7.8688 31.9874L13.9162 39.4074L20.4841 32.3692L26.5315 44.5299L32.4884 31.6984L36.925 47.9942L39.3681 38.9805L41.9512 30.418L47.1167 38.1212L51.801 30.7496L55.3432 38.9081L57 38.9422",
    stroke: "#A7ADD8",
    strokeWidth: 0.683089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3352 31.9881C11.3352 33.9014 9.78421 35.4527 7.87088 35.4527C5.9572 35.4527 4.40625 33.9014 4.40625 31.9881C4.40625 30.0747 5.9572 28.5234 7.87088 28.5234C9.78421 28.5234 11.3352 30.0747 11.3352 31.9881Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3352 31.9881C11.3352 33.9014 9.78421 35.4527 7.87088 35.4527C5.9572 35.4527 4.40625 33.9014 4.40625 31.9881C4.40625 30.0747 5.9572 28.5234 7.87088 28.5234C9.78421 28.5234 11.3352 30.0747 11.3352 31.9881Z",
    stroke: "#1B4458",
    strokeWidth: 0.683089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9992 44.5291C29.9992 46.4424 28.4483 47.9937 26.5349 47.9937C24.6213 47.9937 23.0703 46.4424 23.0703 44.5291C23.0703 42.6157 24.6213 41.0645 26.5349 41.0645C28.4483 41.0645 29.9992 42.6157 29.9992 44.5291Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9992 44.5291C29.9992 46.4424 28.4483 47.9937 26.5349 47.9937C24.6213 47.9937 23.0703 46.4424 23.0703 44.5291C23.0703 42.6157 24.6213 41.0645 26.5349 41.0645C28.4483 41.0645 29.9992 42.6157 29.9992 44.5291Z",
    stroke: "#1B4458",
    strokeWidth: 0.683089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9845 31.6993C34.9845 33.0757 33.8687 34.1915 32.4923 34.1915C31.1158 34.1915 30 33.0757 30 31.6993C30 30.3229 31.1158 29.207 32.4923 29.207C33.8687 29.207 34.9845 30.3229 34.9845 31.6993Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.4923,
    cy: 31.6993,
    r: 2.49225,
    stroke: "#1B4458",
    strokeWidth: 0.683089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3899 47.9939C40.3899 49.9073 38.8389 51.4586 36.9252 51.4586C35.0119 51.4586 33.4609 49.9073 33.4609 47.9939C33.4609 46.0806 35.0119 44.5293 36.9252 44.5293C38.8389 44.5293 40.3899 46.0806 40.3899 47.9939Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3899 47.9939C40.3899 49.9073 38.8389 51.4586 36.9252 51.4586C35.0119 51.4586 33.4609 49.9073 33.4609 47.9939C33.4609 46.0806 35.0119 44.5293 36.9252 44.5293C38.8389 44.5293 40.3899 46.0806 40.3899 47.9939Z",
    stroke: "#1B4458",
    strokeWidth: 0.683089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5018 39.407C16.5018 40.8336 15.3453 41.9897 13.919 41.9897C12.4924 41.9897 11.3359 40.8336 11.3359 39.407C11.3359 37.9803 12.4924 36.8242 13.919 36.8242C15.3453 36.8242 16.5018 37.9803 16.5018 39.407Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5018 39.407C16.5018 40.8336 15.3453 41.9897 13.919 41.9897C12.4924 41.9897 11.3359 40.8336 11.3359 39.407C11.3359 37.9803 12.4924 36.8242 13.919 36.8242C15.3453 36.8242 16.5018 37.9803 16.5018 39.407Z",
    stroke: "#1B4458",
    strokeWidth: 0.683089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0682 32.3679C23.0682 33.7946 21.9117 34.9507 20.4854 34.9507C19.0588 34.9507 17.9023 33.7946 17.9023 32.3679C17.9023 30.9413 19.0588 29.7852 20.4854 29.7852C21.9117 29.7852 23.0682 30.9413 23.0682 32.3679Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0682 32.3679C23.0682 33.7946 21.9117 34.9507 20.4854 34.9507C19.0588 34.9507 17.9023 33.7946 17.9023 32.3679C17.9023 30.9413 19.0588 29.7852 20.4854 29.7852C21.9117 29.7852 23.0682 30.9413 23.0682 32.3679Z",
    stroke: "#1B4458",
    strokeWidth: 0.683089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0922 38.9795C41.0922 39.9304 40.3214 40.7013 39.3705 40.7013C38.4193 40.7013 37.6484 39.9304 37.6484 38.9795C37.6484 38.0287 38.4193 37.2578 39.3705 37.2578C40.3214 37.2578 41.0922 38.0287 41.0922 38.9795Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0922 38.9795C41.0922 39.9304 40.3214 40.7013 39.3705 40.7013C38.4193 40.7013 37.6484 39.9304 37.6484 38.9795C37.6484 38.0287 38.4193 37.2578 39.3705 37.2578C40.3214 37.2578 41.0922 38.0287 41.0922 38.9795Z",
    stroke: "#1B4458",
    strokeWidth: 0.683089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6971 38.1218C49.6971 39.5485 48.5406 40.7046 47.1143 40.7046C45.6877 40.7046 44.5312 39.5485 44.5312 38.1218C44.5312 36.6952 45.6877 35.5391 47.1143 35.5391C48.5406 35.5391 49.6971 36.6952 49.6971 38.1218Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6971 38.1218C49.6971 39.5485 48.5406 40.7046 47.1143 40.7046C45.6877 40.7046 44.5312 39.5485 44.5312 38.1218C44.5312 36.6952 45.6877 35.5391 47.1143 35.5391C48.5406 35.5391 49.6971 36.6952 49.6971 38.1218Z",
    stroke: "#1B4458",
    strokeWidth: 0.683089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9016 30.7496C53.9016 31.9102 52.961 32.8508 51.8004 32.8508C50.6398 32.8508 49.6992 31.9102 49.6992 30.7496C49.6992 29.5891 50.6398 28.6484 51.8004 28.6484C52.961 28.6484 53.9016 29.5891 53.9016 30.7496Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.8004,
    cy: 30.7496,
    r: 2.10118,
    stroke: "#1B4458",
    strokeWidth: 0.683089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5331 30.4187C44.5331 31.8453 43.3766 33.0015 41.9503 33.0015C40.5237 33.0015 39.3672 31.8453 39.3672 30.4187C39.3672 28.9921 40.5237 27.8359 41.9503 27.8359C43.3766 27.8359 44.5331 28.9921 44.5331 30.4187Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5331 30.4187C44.5331 31.8453 43.3766 33.0015 41.9503 33.0015C40.5237 33.0015 39.3672 31.8453 39.3672 30.4187C39.3672 28.9921 40.5237 27.8359 41.9503 27.8359C43.3766 27.8359 44.5331 28.9921 44.5331 30.4187Z",
    stroke: "#1B4458",
    strokeWidth: 0.683089,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8868 6.67969L24.8281 11.4712V13.6469L31.1071 16.5715H32.4876V14.277L28.2685 11.5522L32.3312 11.3725V8.67567L31.8868 6.67969Z",
    fill: "#D7DCFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8868 19.8538L24.8281 15.0572L31.8868 10.2656L32.3332 12.2613L28.1558 15.0633L32.4859 17.8616L31.8868 19.8538Z",
    fill: "#50B3FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3331 12.2622L31.8867 10.2665V7.88867L32.3341 9.88432L32.3331 12.2622Z",
    fill: "#50B3FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8868 7.88867L24.8281 12.6809V15.0584L31.8868 10.2665V7.88867Z",
    fill: "#BBDFFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1562 15.0665L32.4846 17.8672V15.489L29.9599 13.8574L28.1562 15.0665Z",
    fill: "#BBDFFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8868 19.8538L24.8281 15.0572L31.8868 10.2656L32.3332 12.2613L28.1558 15.0633L32.4859 17.8616L31.8868 19.8538Z",
    stroke: "#1B4458",
    strokeWidth: 0.512317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3331 12.2622L31.8867 10.2665V7.88867L32.3341 9.88432L32.3331 12.2622Z",
    stroke: "#1B4458",
    strokeWidth: 0.512317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8868 7.88867L24.8281 12.6809V15.0584L31.8868 10.2665V7.88867Z",
    stroke: "#1B4458",
    strokeWidth: 0.512317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1562 15.0666L32.4846 17.8652V15.4867L29.9599 13.8555L28.1562 15.0666Z",
    stroke: "#1B4458",
    strokeWidth: 0.512317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApyLogo);
export default __webpack_public_path__ + "static/media/apy_logo.d80eb9425aa281bae034f824862bcb54.svg";
export { ForwardRef as ReactComponent };